import { render } from "./0_SplashScreen.vue?vue&type=template&id=6529cb33&scoped=true"
import script from "./0_SplashScreen.vue?vue&type=script&lang=js"
export * from "./0_SplashScreen.vue?vue&type=script&lang=js"

import "./0_SplashScreen.vue?vue&type=style&index=0&id=6529cb33&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6529cb33"]])

export default __exports__